import join from 'nllib/src/uri/join';

export default {
    components: {},
    data() {
        return {}
    },
    methods: {},
    created() {
    },
    mounted() {
        const init_favicon = function () {
            const appConfig = global.appConfig;
            if (!appConfig) return;
            const environment = appConfig.environment;
            if (environment !== `local`) {
                const VUE_APP_vue_router_history_public_path = process.env.VUE_APP_vue_router_history_public_path;
                const href = join(VUE_APP_vue_router_history_public_path, `/favicon.ico`);

                const link = document.createElement(`link`);
                link.rel = `icon`;
                link.href = href;
                document.querySelector(`head`).appendChild(link);
            }
        };
        init_favicon();
    },
}
